import React, { useState } from "react";
import "../common/common.css";
import "./loginLanding.css";
import { useTranslation } from "react-i18next";
import { authApiEndpoint } from "../../utils/env";

const FORGOT_ENDPOINT = authApiEndpoint("/api/ApplicationUser/ForgotPassword");

export default function ForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    if (!email.trim()) {
      setError("Email is required");
      return;
    }
    setSubmitting(true);
    try {
      const res = await fetch(FORGOT_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim() }),
      });
      let body = null;
      try {
        body = await res.json();
      } catch {
        body = null;
      }
      if (!res.ok) {
        const msg = body?.message || "Unable to process request";
        throw new Error(msg);
      }

      setMessage(
        "If an account exists for this email, a reset link has been sent."
      );
    } catch (err) {
      setError(err.message || "Unable to process request");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="landing-root">
      <div className="landing-hero">
        <div className="hero-top">
          <div className="brand">
            <img
              src="/brand-logo.svg"
              alt="DIXI Vault"
              className="brand-logo"
            />
            <span className="brand-name">DIXI Vault</span>
          </div>
        </div>

        <div className="hero-content">
          <div className="hero-copy">
            <div className="eyebrow">Reset your password</div>
            <h1>Forgot password</h1>
            <p>
              Enter the email address associated with your account and we'll
              send you a link to reset your password.
            </p>
          </div>
          <div className="hero-art">
            <img src="/illustration-hero.svg" alt="Password reset" />
          </div>
        </div>
      </div>

      <aside className="auth-panel" aria-label="Forgot password">
        <form onSubmit={onSubmit} className="auth-card">
          <div className="chip">Password help</div>
          <label className="f-label">
            Email
            <input
              className="f-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              autoComplete="username"
            />
          </label>
          {error && (
            <div className="error-text" role="alert">
              {error}
            </div>
          )}
          {message && !error && (
            <div className="success-text" role="status">
              {message}
            </div>
          )}
          <button className="cta submit" disabled={submitting} type="submit">
            {submitting ? "Sending…" : "Send reset link"}
          </button>
          <div className="small-links">
            <a href="/login">Back to sign in</a>
          </div>
        </form>
      </aside>
    </div>
  );
}
